import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import css from './participation-result.scss';

/**
 * Displays result or avg. result in student participation tables
 */

class ParticipationResult extends Component {
    static propTypes = {
        result: PropTypes.number,
        isAverage: PropTypes.bool
    };

    isResultNA() {
        return this.props.result == null;
    }

    renderPercent() {
        const { result } = this.props;
        let className = css.attempt;
        if (this.isResultNA()) {
            className += ` ${css['null-attempt']}`;
        }

        return (
            <div className={className}>
                <span>{this.isResultNA() ? '- ' : result}</span>
                <span className={css.percent}>%</span>
            </div>
        );
    }

    render() {
        const { isAverage } = this.props;
        const na = window.i18n._('Label - NA');

        return (
            <div className={css.component}>
                {this.isResultNA() && isAverage === true ? (
                    <div className={css['null-attempt']}>{na}</div>
                ) : (
                    this.renderPercent()
                )}
                {isAverage === true && <div className={css.avg}>Avg</div>}
            </div>
        );
    }
}

export default styleable(css)(ParticipationResult);



// WEBPACK FOOTER //
// ./components/participation-result/participation-result.js